import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { NAV, SITE } from '../data/site';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50">
      <div className="bg-[#C84B27] text-[#FDFBF7] text-center text-xs sm:text-sm py-1.5 px-4 font-medium tracking-wide">
        Produk kami non-halal — kami menyatakannya dengan terbuka.
      </div>
      <div className="bg-[#FDFBF7]/95 backdrop-blur-md border-b border-[#E2D3BE]">
        <div className="mx-auto max-w-6xl px-5 h-16 flex items-center justify-between gap-4">
          <Link
            to="/"
            data-testid="nav-logo"
            className="flex items-baseline gap-2 shrink-0"
            aria-label="Ayam Goreng Widuran — Beranda"
          >
            <span className="font-display text-xl sm:text-2xl font-bold text-[#2B1B12] tracking-tight">
              Ayam Goreng Widuran
            </span>
            <span className="font-pricemono text-[10px] tracking-widest text-[#C84B27] uppercase hidden sm:inline">
              Solo · {SITE.since}
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-7" aria-label="Navigasi utama">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                data-testid={n.testid}
                className="nav-link text-sm font-semibold text-[#2B1B12] hover:text-[#C84B27]"
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            className="md:hidden inline-flex flex-col justify-center gap-1.5 w-11 h-11 items-center rounded-md border border-[#E2D3BE] bg-white"
            aria-expanded={open}
            aria-controls="mobile-nav"
            aria-label={open ? 'Tutup menu navigasi' : 'Buka menu navigasi'}
            onClick={() => setOpen((v) => !v)}
          >
            <span className={`block w-5 h-0.5 bg-[#2B1B12] transition-transform ${open ? 'translate-y-1 rotate-45' : ''}`} />
            <span className={`block w-5 h-0.5 bg-[#2B1B12] transition-opacity ${open ? 'opacity-0' : ''}`} />
            <span className={`block w-5 h-0.5 bg-[#2B1B12] transition-transform ${open ? '-translate-y-2 -rotate-45' : ''}`} />
          </button>
        </div>
        <nav
          id="mobile-nav"
          aria-label="Navigasi seluler"
          className={`${open ? 'block' : 'hidden'} md:hidden border-t border-[#E2D3BE] bg-[#FDFBF7]`}
        >
          <ul className="px-5 py-3 flex flex-col">
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink
                  to={n.to}
                  end={n.to === '/'}
                  data-testid={`mobile-${n.testid}`}
                  onClick={() => setOpen(false)}
                  className="block py-3 text-base font-semibold text-[#2B1B12] border-b border-[#F5EFE6] last:border-0 hover:text-[#C84B27] transition-colors"
                >
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
